module.exports = __webpack_public_path__ + "media/images/agenda-20minutes-5ddea2efa162a403d973adc7217ac513.jpg";